import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { QueryClientProvider } from "@tanstack/react-query"

import App from "./App"
import { queryClient } from "@/lib/queryClient"
import { AuthProvider } from "@/contexts/AuthContext"
import "@/styles/globals.css"

/**
 * React 18 entrypoint. Notably:
 *   - createRoot (not legacy ReactDOM.render)
 *   - StrictMode is intentionally OFF — we'll re-enable once we've validated
 *     no double-effect bugs in our own code. Safe choice for the new app
 *     since we control everything; can flip on later.
 */
const rootEl = document.getElementById("root")
if (!rootEl) throw new Error("#root not found in index.html")

ReactDOM.createRoot(rootEl).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </QueryClientProvider>
)
